import { render, staticRenderFns } from "./PendingKits.vue?vue&type=template&id=1442246c&scoped=true&"
import script from "./PendingKits.vue?vue&type=script&lang=js&"
export * from "./PendingKits.vue?vue&type=script&lang=js&"
import style0 from "./PendingKits.vue?vue&type=style&index=0&id=1442246c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1442246c",
  null
  
)

export default component.exports